import type { RootState } from 'store';

export const maintenanceModeSelector = (state: RootState) =>
  state.common.systemStatus.maintenanceMode;
export const offlineStatusSelector = (state: RootState) => state.common.systemStatus.offline;
